<template>
  <div>  
    <h1 class="text-center mb-3">Mis alertas</h1>
    <alertsTable :alerts="procurementAlerts.alerts"
      :current_page="procurementAlerts.current_page"
      :total_pages="procurementAlerts.total_pages"
      :alert_type="'procurement'"/>
  </div>
</template>

<script>
import {mapActions, mapState } from 'vuex';

import alertsTable from '@/components/alerts/alerts_table.vue';

export default {
  name: 'alertsDashboard',
  components: {
    alertsTable,
  },
  data() {
    return {
      alert: null,
    };
  },
  mounted() {
        this.indexAlerts({ alert_type: 'procurement' });
  },
  methods: {
    ...mapActions('alertsModule', {
      indexAlerts: 'indexAlerts',
    }),
  },
  computed: {
    ...mapState({
      procurementAlerts: state => state.alertsModule.procurement,
    }),
  },
};
</script>

<style scoped>

</style>
